module.exports = __webpack_public_path__ + "static/scale-model-of-austin-texas-80b0ac24eb768c2fce4e96930ad49006.png";